// extracted by mini-css-extract-plugin
export var arrows = "_r-6";
export var decrementer = "_r-a";
export var disabled = "_r-4";
export var error = "_r-1";
export var hiddenText = "_r-b";
export var incrementer = "_r-9";
export var input = "_r-8";
export var inputWrapper = "_r-0";
export var leadingIcon = "_r-c";
export var readonly = "_r-3";
export var regular = "_r-7";
export var small = "_r-5";
export var warning = "_r-2";